import type { IconSvgObject } from './types';

const Uv02Icon: IconSvgObject = [
  ["path", { d: "M17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.999 6L17.5 7.49902M12 3V5M22 13H20M4 13H2M6.5 7.49902L5.00098 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 16L15 21H16L18 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 16V20C10 20.5523 9.55228 21 9 21H7C6.44772 21 6 20.5523 6 20V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Uv02Icon;
